export default __webpack_public_path__ + "static/Vol 3 - TA 5 - CTMP (with appendices)-93ba7b1b6c3659ba2ee2f8e5f2b4e4ae.pdf";